export default {
  path: '/orders',
  name: 'orders',
  component: () => import('../components/order/Layout'),
  redirect: { name: 'OrderList' },
  meta: {
    breadcrumb: 'order.orders',
  },
  children: [
    {
      name: 'OrderList',
      path: '',
      component: () => import('../views/order/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'OrderCreate',
      path: 'new',
      component: () => import('../views/order/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'OrderUpdate',
      path: ':id/edit',
      component: () => import('../views/order/Update'),
      meta: {
        breadcrumb: 'order.order',
      },
    },
    {
      name: 'OrderShow',
      path: ':id',
      component: () => import('../views/order/Show'),
      meta: {
        breadcrumb: 'order.order',
      },
    }
  ]
};
